import c from 'classnames';

import { HeadingTags } from 'types/html-types';

import s from './Heading.module.scss';
import { HoverMagic } from 'components/hover-magic/HoverMagic';

type HeadingProps = {
  type?: HeadingTags;
  as?: HeadingTags;
  className?: string;
  style?: React.CSSProperties;
  skipGradient?: boolean;
  children: React.ReactNode;
};

const Heading = ({
  type = 'h1',
  as,
  children,
  className,
  style,
  skipGradient = false,
}: HeadingProps) => {
  if (!children) {
    return null;
  }

  return (
    <HoverMagic
      className={c(s[type], className, { [s.gradientTitle]: !skipGradient })}
      style={style}
      as={as}
      type={type}
      skipGradient={skipGradient}
    >
      {children}
    </HoverMagic>
  );
};

export const H1 = (props: HeadingProps) => <Heading type="h1" {...props} />;

export const H2 = (props: HeadingProps) => <Heading type="h2" {...props} />;

export const H3 = (props: HeadingProps) => <Heading type="h3" {...props} />;

export const H4 = (props: HeadingProps) => <Heading type="h4" {...props} />;

export const H5 = (props: HeadingProps) => <Heading type="h5" {...props} />;

export const H6 = (props: HeadingProps) => <Heading type="h6" {...props} />;
